import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "e-library";
export type library_list = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    library_category_name: string;
    search?: string;
    id_library_type?: number;
    start_date?: string;
    end_date?: string;
}
export type library_details = {
    id_library_detail: number | null;
    library_detail_type: string; // "SALES" etc.
    library_detail_number: string;
    price_amount?: number | null;
}
export type e_library_type = {
    id_library_category: number | null;
    library_category_name: string;
    library_head_name: string;
    id_library_author_by: number | null;
    library_author_by: string;
    id_library_author_publisher: number | null;
    library_author_publisher: string;
    library_page: number | string | null;
    library_episodes: number | null;
    library_category_desc: string;
    language: string;
    is_draft: boolean;
    library_head_status: string; // "NEW" etc.
    library_payment_day: number | string | null;
    library_payment_hour: number | string | null;
    library_rent_day: number | string | null;
    library_rent_hour: number | string | null;
    library_head_types: {
        id_library_type: number | null;
        library_type_name: string;
        id_library_head_type: number | null;

    }[];
    library_details: library_details[]
    library_files: {
        id_library_file: number | null;
        library_file_type: string;
        id_library_file_document: number | null;
        library_file_document: string;
        seq: number | null;
        link_file: string;
        is_example: boolean;
    }[];
};


export type upload_file_e_library = {
    library_category_name: string;
}
export type file_response_e_library = {
    id_library_file: number | null;
    library_file_type: string;
    id_library_file_document: number | null;
    library_file_document: string;
    seq: number | null;
    link_file: string;
    is_example: boolean;
}

export class ELibraryApi extends BaseAPI {
    static list(params: library_list): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, {
            params
        })
    }
    static create(body: e_library_type): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_library_head: number, body: e_library_type): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_library_head}`, body)
    }
    static findOne(id_library_head: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_library_head}`)
    }
    static delete(id_library_head: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_library_head}`)
    }
    static category(): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/category`)
    }
    static documentCategory(id_library_category: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/list/document-category`, {
            params: {
                id_library_category
            }
        })
    }
    static createFile(library_category_name: string, body: FormData, is_example?: boolean): Promise<AxiosResponse> {
        return this.api.post(`${path}/upload-file`, body, {
            params: {
                library_category_name,
                is_example: is_example
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    static updateStatus(id_library_head: number, body: { status: string }): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_library_head}/status`, body)
    }
}